import { Route } from "react-router";
import { ProfileSettingsPage } from "./ProfileSettingsPage";

export const useProfileSettingsRouter = () => {
    return <Route path="profile-settings" element={<ProfileSettingsPage />} />;
};
